<template>
  <button :class="{'btn-fill-animation-active': isSelected}" @click="click"
      class="btn btn-fill-animation mx-1">
    <span>{{ value }}</span>
  </button>
</template>

<script>
export default {
  name: 'BaseFilterItem',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  methods: {
    click () {
      this.$parent.switchItem(this.value)
    }
  },
  computed: {
    isSelected () {
      return this.$parent.$data.selected === this.value
    }
  }
}
</script>

<style scoped>

</style>
